import { ApiPaths } from "../../api/ApiPaths";
import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { ApiRequest } from "../../api/ApiRequest";

export type GetDetectionListSuccessResponseType = {
    detections: [{
        id: string,
        category: string,
        dateTime: string,
        sentNotification: boolean
    }],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
};

export async function getDetectionList(
    careRecipientId: CareRecipientId
): Promise<GetDetectionListSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.detection.list,
        {
            care_recipient_id: careRecipientId.value
        },
        () => {},
        () => {});
}